import React from "react";
import LocalizedLink from 'helpers/LocalizeLink';
import { CartItemsCount } from 'helpers/cart/CartItemsCount';

const HeaderCartButton = (props) => {
    const CartIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 12 35 35">
                <defs></defs>
                <g transform="translate(-1060 -41)">
                    <g transform="translate(778.864 -1005.158)">
                        <path className={'a'} fill="#fff" d="M295.866,1077.776a.669.669,0,0,0,.707.566h8.321a.717.717,0,0,0,.727-.566l1.138-5.943H294.672Z" />
                        <path className={'a'} fill="#fff" d="M298.581,1058.158h-.006a17.438,17.438,0,1,0,17.437,17.439v0A17.433,17.433,0,0,0,298.581,1058.158Zm-2.452,27.454a1.989,1.989,0,1,1,1.989-1.989A1.991,1.991,0,0,1,296.129,1085.612Zm9.282,0a1.989,1.989,0,1,1,1.989-1.989A1.991,1.991,0,0,1,305.411,1085.612Zm2.172-7.451a2.725,2.725,0,0,1-2.709,2.181h-8.336a2.7,2.7,0,0,1-2.633-2.173l-1.426-7.1c-.006-.027-.012-.054-.016-.081l-.685-3.412h-2.6a1,1,0,0,1,0-2H292.6a1,1,0,0,1,.98.8l.694,3.45h13.7a1,1,0,0,1,.982,1.188Z" />
                    </g>
                </g>
            </svg>
        )
    }

    return (
        <LocalizedLink to={'/cart'} dti="cart-btn" className="logato_zone-cart text-null ml-12">
            <CartItemsCount />
            <CartIcon />
        </LocalizedLink>
    )
}

export default HeaderCartButton;